import { compareDesc } from 'date-fns';
import { Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { DataSource, PresetService } from '../../backend';
import { createParamLabelsView, parseParamsStr } from '../../builder-selection';
import { currentBuilderState } from '../builder.state';
import { PresetView } from '../model/preset-view.model';

import { filterPresets } from './filter-presets.function';

export function loadPresets(): Observable<void> {
    const presetService =
        epicDependencies.injector.get<PresetService>(PresetService);

    const state = currentBuilderState();

    return presetService.list().pipe(
        catchErrorLogRet([]),
        tap((ret) => {
            state.presets = ret
                ?.map((e): PresetView => {
                    const bp = parseParamsStr(e.parameters);
                    const viewParamLabels = createParamLabelsView(bp);

                    const colours = {
                        [DataSource.Cache]:
                            'cmps-report-bg-color-ukn-108 cmps-cdk-color-blue-100',
                        [DataSource.Raw]:
                            'cmps-report-bg-color-ukn-109 cmps-cdk-color-green-100',
                    };

                    return {
                        ...e,
                        viewParamLabels,
                        dataSourceLabelColour: colours[bp.dataSource],
                        open: null,
                        deleting: null,
                    };
                })
                ?.sort((a, b) =>
                    compareDesc(
                        a.updatedOn ?? a.createdOn,
                        b.updatedOn ?? b.createdOn,
                    ),
                );

            filterPresets();
        }),
        mapTo(null),
    );
}
